/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentFirmwareFamily } from './equipment-firmware-family';
import { EquipmentSchedulesByEquipmentResponseDto } from './equipment-schedules-by-equipment-response-dto';
import { EquipmentEventSeverities } from './equipment-event-severities';
import { EquipmentModes } from './equipment-modes';
import { SearchEquipmentWorkerResponse } from './search-equipment-worker-response';
import { EquipmentStatuses } from './equipment-statuses';


export interface SearchEquipmentWithSchedulesResponse { 
    id: string;
    modelName: string;
    subModelName?: string | null;
    serialNumber?: string | null;
    ipAddress: string;
    facilityName: string;
    containerId?: string | null;
    containerName?: string | null;
    containerNumber?: number | null;
    macAddress: string;
    currentHashrate: number;
    hashrateUnitId: number;
    currentPower: number;
    uptime?: number | null;
    collectedAt?: string | null;
    telemetryFresh?: boolean;
    fanSpeeds?: Array<number> | null;
    status: EquipmentStatuses;
    mode?: EquipmentModes;
    availableModes?: Array<EquipmentModes> | null;
    unavailableModes?: Array<EquipmentModes> | null;
    syntheticSleepActive?: boolean;
    firmwareFamily: EquipmentFirmwareFamily;
    workers?: Array<SearchEquipmentWorkerResponse> | null;
    faultSeverity?: EquipmentEventSeverities;
    faultCount?: number | null;
    schedules: EquipmentSchedulesByEquipmentResponseDto;
}



